import { each } from '@antv/util';
import { IList, ListItem } from '../../../dependents';
import Element from '../../../geometry/element';
import { LooseObject } from '../../../interface';
import Action from '../base';
import { getComponents } from '../util';
import { getCurrentElement, getDelegationObject, getElementValue, isList, getScaleByField } from '../util';

/** @ignore */
interface ListStateCfg {
  componentNames: string[];
}

/**
 * åè¡¨é¡¹ç¶æ Action çåºç¡ç±»
 * @class
 * @ignore
 */
class ListState extends Action<ListStateCfg> {
  protected stateName: string = '';
  protected ignoreItemStates = [];

  /** è·åè§¦åçåè¡¨ç»ä»¶ */
  protected getTriggerListInfo() {
    const delegateObject = getDelegationObject(this.context);
    let info: LooseObject = null;
    if (isList(delegateObject)) {
      info = {
        item: delegateObject.item,
        list: delegateObject.component,
      };
    }
    return info;
  }
  // è·åææåè®¸æ§è¡ Action çç»ä»¶
  protected getAllowComponents() {
    const view = this.context.view;
    const components = getComponents(view);
    const rst = [];
    each(components, (component) => {
      if (component.isList() && this.allowSetStateByElement(component)) {
        rst.push(component);
      }
    });
    return rst;
  }

  /** æ¯å¦å­å¨æå®çç¶æ */
  protected hasState(list: IList, item: ListItem) {
    return list.hasState(item, this.stateName);
  }

  /** æ¸çç»ä»¶çç¶æ */
  protected clearAllComponentsState() {
    const components = this.getAllowComponents();
    each(components, (component) => {
      component.clearItemsState(this.stateName);
    });
  }

  // ä¸æ¯ææç component é½è½è¿è¡ activeï¼ç®åä»æ¯æåç±» scale å¯¹åºçç»ä»¶
  protected allowSetStateByElement(component): boolean {
    const field = component.get('field');
    if (!field) {
      return false;
    }
    if (this.cfg && this.cfg.componentNames) {
      const name = component.get('name');
      // å¦æéç½®äºéå¶ç component nameï¼åè¦è¿è¡æ£æµ
      if (this.cfg.componentNames.indexOf(name) === -1) {
        return false;
      }
    }
    const view = this.context.view;
    const scale = getScaleByField(view, field);
    return scale && scale.isCategory;
  }
  // æ£æµæ¯å¦åè®¸è§¦åå¯¹åºçç¶ææ¹åäºä»¶
  private allowSetStateByItem(item: ListItem, list: IList) {
    const ignoreStates = this.ignoreItemStates;
    if (ignoreStates.length) {
      const filterStates = ignoreStates.filter((state) => {
        return list.hasState(item, state);
      });
      return filterStates.length === 0;
    }
    return true; // æ²¡æå®ä¹å¿½ç¥çç¶ææ¶ï¼åè®¸
  }

  // è®¾ç½®ç»ä»¶ç item active
  private setStateByElement(component, element: Element, enable: boolean) {
    const field = component.get('field');
    const view = this.context.view;
    const scale = getScaleByField(view, field);
    const value = getElementValue(element, field);
    const text = scale.getText(value);
    this.setItemsState(component, text, enable);
  }

  // è®¾ç½®ç¶æ
  protected setStateEnable(enable: boolean) {
    const element = getCurrentElement(this.context);
    if (element) {
      // trigger by element
      const components = this.getAllowComponents();
      each(components, (component) => {
        this.setStateByElement(component, element, enable);
      });
    } else {
      // è¢«ç»ä»¶è§¦å
      const delegateObject = getDelegationObject(this.context);
      if (isList(delegateObject)) {
        const { item, component } = delegateObject;
        if (this.allowSetStateByElement(component) && this.allowSetStateByItem(item, component)) {
          this.setItemState(component, item, enable);
        }
      }
    }
  }

  // å¤ä¸ª item è®¾ç½®ç¶æ
  protected setItemsState(list: IList, name: string, enable: boolean) {
    const items = list.getItems();
    each(items, (item) => {
      if (item.name === name) {
        this.setItemState(list, item, enable);
      }
    });
  }

  // åä¸ª item è®¾ç½®ç¶æ
  protected setItemState(list: IList, item: ListItem, enable: boolean) {
    list.setItemState(item, this.stateName, enable);
  }

  /**
   * è®¾ç½®ç¶æ
   */
  public setState() {
    this.setStateEnable(true);
  }

  /**
   * åæ¶ç¶æ
   */
  public reset() {
    this.setStateEnable(false);
  }

  /**
   * åæ¢ç¶æ
   */
  public toggle() {
    const triggerInfo = this.getTriggerListInfo();
    if (triggerInfo && triggerInfo.item) {
      const { list, item } = triggerInfo;
      const enable = this.hasState(list, item);
      this.setItemState(list, item, !enable);
    }
  }

  /**
   * åæ¶ç¶æ
   */
  public clear() {
    const triggerInfo = this.getTriggerListInfo();
    if (triggerInfo) {
      triggerInfo.list.clearItemsState(this.stateName);
    } else {
      this.clearAllComponentsState();
    }
  }
}

export default ListState;
